/**
 * 字体预加载（M0 字体任务「首屏无字体闪替」）。
 * `?url` 导入让 Vite 在构建期解析为带 hash 的产物路径，与 CSS @font-face
 * 引用的是同一文件 → preload 命中缓存，不会二次下载。
 * 只预载 serif（首屏标题字重 600）与 sans（正文 400）两个关键子集；
 * 霞鹜文楷是 unicode-range 分片，按需加载，不预载。
 */
import serifWoff2 from '@chronospeak/ui/fonts/NotoSerifSC-subset.woff2?url';
import sansWoff2 from '@chronospeak/ui/fonts/NotoSansSC-subset.woff2?url';

export function preloadFonts(): void {
  for (const href of [serifWoff2, sansWoff2]) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.crossOrigin = 'anonymous';
    link.href = href;
    document.head.appendChild(link);
  }
}
